import userTypes from "./user.types";
import { auth } from "../../components/Firebase/utils";

export const emailSignInStart = userCredentials => ({
  type:userTypes.EMAIL_SIGN_IN_START,
  payload: userCredentials
})
export const googleSignInStart = () => ({
  type: userTypes.GOOGLE_SIGN_IN_START
});
export const signInSuccess = user =>
 ({ 
   type: userTypes.SIGN_IN_SUCCESS,
  payload:user
})

export const checkUserSession = () =>
({
  type:userTypes.CHECK_USER_SESSION
})

export const signOutStart = () =>
({
  type:userTypes.SIGN_OUT_START
})

export const signOutSuccess = () =>
({
  type:userTypes.SIGN_OUT_SUCCESS
})

export const signUpStart = userCredentials =>
({
  type:userTypes.SIGN_UP_START,
  payload:userCredentials
})



export const setCurrentUser = user =>
    ({
        type: userTypes.SET_CURRENT_USER,
        payload: user
    })
export const registerSuccess = () => {
  return {
    type: userTypes.REGISTER_SUCCESS,
    payload: true,
  }
}
export const userError = err => ({
  type: userTypes.USER_ERROR,
  payload: err
});
export const logInWithEmailAndPassword =  (email, password)=> async (dispatch) =>{
    try {
        await auth.signInWithEmailAndPassword(auth, email, password);
        dispatch(signInSuccess())
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};
export const register = (displayName,email, password,confirmPassword) => async (dispatch) => {
    if(password !==confirmPassword)
    {
        const err = ['Password don\'t match']
       dispatch(userError(err))
        return
    }
  try {
    await auth.createUserWithEmailAndPassword(email, password)
    dispatch(registerSuccess())
  } catch (error) {
    throw error
  }
};